import { render, staticRenderFns } from "./SlidePreview.vue?vue&type=template&id=56f6546c&scoped=true"
import script from "./SlidePreview.vue?vue&type=script&lang=js"
export * from "./SlidePreview.vue?vue&type=script&lang=js"
import style0 from "./SlidePreview.vue?vue&type=style&index=0&id=56f6546c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f6546c",
  null
  
)

export default component.exports